export default {
  SKILLSDIAGNOSTIC_PENDING: 'SKILLSDIAGNOSTIC_PENDING',
  SKILLSDIAGNOSTIC_COMPLETE: 'SKILLSDIAGNOSTIC_COMPLETE',
  SKILLSDIAGNOSTIC_ERROR: 'SKILLSDIAGNOSTIC_ERROR',
}